import React from "react";
import { useSelector } from "react-redux";
import GoogleChart, { commonOptions } from "../../../../components/charts/googleChart/googleChart";
import NoData from "../../../../components/noData/noData";

const PieCharts = () => {
  const pieCharts = useSelector((state) => state.memberVisits.pieCharts);

  if (!pieCharts) return null;

  return (
    <div className="section pie-charts">
      {pieCharts.map(({ data_table: { cols, rows }, options }, index) => (
        <div key={index} className="section__el pie-chart">
          {rows.length ? (
            <GoogleChart
              width={675}
              height={300}
              chartType="PieChart"
              columns={cols}
              rows={rows}
              options={{ ...commonOptions, ...options }}
              showCurrency={false}
              showAdditionTooltip={false}
              showXLSX={false}
            />
          ) : (
            <NoData />
          )}
        </div>
      ))}
    </div>
  );
};

export default PieCharts;
